import * as React from "react"

export const SourcePluginsIcon = ({
  width = 40,
  height = 40,
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...rest}
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width={width} height={height} rx="8" fill="#F9F2FF" />
    <path
      d="M20.5 24V28.1459C20.5 29.2822 21.142 30.321 22.1584 30.8292V30.8292C23.0029 31.2515 23.9971 31.2515 24.8416 30.8292L25.5 30.5"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 14V9"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 13V9"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 13V9"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 17.3333C28 16.4493 27.6049 15.6014 26.9016 14.9763C26.1984 14.3512 25.2446 14 24.25 14H16.75C15.7554 14 14.8016 14.3512 14.0984 14.9763C13.3951 15.6014 13 16.4493 13 17.3333V20.6667C13 21.5507 13.3951 22.3986 14.0984 23.0237C14.8016 23.6488 15.7554 24 16.75 24H24.25C25.2446 24 26.1984 23.6488 26.9016 23.0237C27.6049 22.3986 28 21.5507 28 20.6667V17.3333Z"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
